import { TA, MS, TT, MT, TM, SM, RE, NM, CM, PN, PT } from './const';
import { TA_BACKGROUND } from '../TA/const';
import { TT_BACKGROUND } from '../TT/const';
import { MT_BACKGROUND } from '../MT/const';
import { TM_BACKGROUND } from '../TM/const';
import { SM_BACKGROUND } from '../SM/const';
import { NM_BACKGROUND } from '../NM/const';
import { RE_BACKGROUND } from '../RE/const';
import { CM_BACKGROUND } from '../CM/const';
import { PN_BACKGROUND } from '../PN/const';
import { PT_BACKGROUND } from '../PT/const';
import { Background as TriangulaBackground } from '../TA/COMPONENTS/Background';
import { Background as TurboTilesBackground } from '../TT/COMPONENTS/Background';
import { Background as MindShapesBackground } from '../MS/COMPONENTS/BackgroundRed';
import { Background as MemoryTwistBackground } from '../MT/COMPONENTS/Background';
import { Background as TriominoBackground } from '../TM/COMPONENTS/Background';
import { Background as SymbolicaBackground } from '../SM/COMPONENTS/Background';
import { Background as NumericaBackground } from '../NM/COMPONENTS/Background';
import { Background as ColorMatchBackground } from '../CM/COMPONENTS/Background';
import { GradientBackground as PairanoiaBackground } from '../PN/COMPONENTS/Background';
import { GradientBackground as RokuEnBackground } from '../RE/COMPONENTS/Background';
import { GradientBackground as PermutileBackground } from '../PT/COMPONENTS/Background';
import TriangulaLogo from '../TA/ASSETS/TriangulaLogo.png';
import TurboTilesLogo from '../TT/ASSETS/TurboTilesLogo.png';
import MindShapesLogo from '../MS/ASSETS/MindShapesLogo.png';
import MemoryTwistLogo from '../MT/ASSETS/MemoryTwistLogo.png';
import TriominoLogo from '../TM/ASSETS/TriominoLogo.png';
import SymbolicaLogo from '../SM/ASSETS/SymbolicaLogo.png';
import NumericaLogo from '../NM/ASSETS/NumericaLogo.png';
import RokuEnLogo from '../RE/ASSETS/RokuEnLogo.png';
import ColorMatchLogo from '../CM/ASSETS/ColorMatchLogo.png';
import PairanoiaLogo from '../PN/ASSETS/PairanoiaLogo.png';
import PermutileLogo from '../PT/ASSETS/PermutileLogo.png';

export const getAppInfo = (app, strip) => {
  switch (app) {
    case TA:
      return { name: 'TRIANGULA', background: TA_BACKGROUND, backgroundImage: TriangulaBackground, icon: TriangulaLogo };
    case MS:
      return { name: strip ? 'MINDSHAPES' : 'MIND SHAPES', backgroundImage: MindShapesBackground, icon: MindShapesLogo };
    case TT:
      return {
        name: strip ? 'TURBOTILES' : 'TURBO TILES',
        background: TT_BACKGROUND,
        backgroundImage: TurboTilesBackground,
        icon: TurboTilesLogo,
      };
    case MT:
      return {
        name: strip ? 'MEMORYTWIST' : 'MEMORY TWIST',
        background: MT_BACKGROUND,
        backgroundImage: MemoryTwistBackground,
        icon: MemoryTwistLogo,
      };
    case TM:
      return { name: 'TRIOMINO', background: TM_BACKGROUND, backgroundImage: TriominoBackground, icon: TriominoLogo };
    case SM:
      return { name: 'SYMBOLICA', background: SM_BACKGROUND, backgroundImage: SymbolicaBackground, icon: SymbolicaLogo };
    case NM:
      return { name: 'NUMERICA', background: NM_BACKGROUND, backgroundImage: NumericaBackground, icon: NumericaLogo };
    case RE:
      return { name: strip ? 'ROKUEN' : 'ROKU-EN', background: RE_BACKGROUND, backgroundImage: RokuEnBackground, icon: RokuEnLogo };
    case CM:
      return {
        name: strip ? 'COLORMATCH' : 'COLOR MATCH',
        background: CM_BACKGROUND,
        backgroundImage: ColorMatchBackground,
        icon: ColorMatchLogo,
      };
    case PN:
      return { name: 'PAIRANOIA', background: PN_BACKGROUND, backgroundImage: PairanoiaBackground, icon: PairanoiaLogo };
    case PT:
      return { name: 'PERMUTILE', background: PT_BACKGROUND, backgroundImage: PermutileBackground, icon: PermutileLogo };
    default:
  }
};
